import { render, staticRenderFns } from "./VentasProductoDia.vue?vue&type=template&id=4b02cff2&"
import script from "./VentasProductoDia.vue?vue&type=script&lang=js&"
export * from "./VentasProductoDia.vue?vue&type=script&lang=js&"
import style0 from "./VentasProductoDia.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports